import { useQuery } from '@tanstack/react-query';
import { createRetryFn } from '../../../config/react-query';
import useApiManager from '../../../hooks/useApiManager';
import type { PhoneNumber } from '../../../services/phoneService';

const usePhoneList = (room: string | undefined) => {
  const apiManager = useApiManager();

  const { data, isLoading, isError, error } = useQuery<PhoneNumber[]>({
    queryKey: ['phoneList', room],
    queryFn: async () => {
      if (!room) {
        return [];
      }
      return apiManager.phone.getPhoneList(room);
    },
    enabled: !!room,
    staleTime: 5 * 60 * 1000,
    retry: createRetryFn({ maxRetries: 2 }),
  });

  return {
    phoneList: data ?? [],
    isLoading,
    isError,
    error,
  };
};

export default usePhoneList;
